// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

// page-specific/etc.
import ReactTags from 'react-tag-autocomplete';
import SchoolMainDetails from 'components/schools/SchoolMainDetails';
import TeacherDetails from 'components/teachers/TeacherDetails';

class ClientProjectsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching: false,

      submissions: [],
      submissionData: null,
      submissionPictureBase64: ''
    };
  }

  componentDidMount() {
    const projectName = this.props.match.params.projectName;
    const submissionId = this.props.match.params.submissionId.replace('-', '');

    this.fetchData(projectName, submissionId);
  }
  componentWillReceiveProps(nextProps) {
    const projectName = nextProps.match.params.projectName;
    const submissionId = nextProps.match.params.submissionId.replace('-', '');

    this.fetchData(projectName, submissionId);
  }

  getEndpoint = (projectName, submissionId) => {
    let endpoint = '';
    switch (projectName) {
      case 'alpitour-2021':
        endpoint = `${Settings.V3_API_URL}/etc/projects/alpitour/terramiotesoro/2021/submissions`;
        break;
      case 'alpitour-2020':
        endpoint = `${Settings.V3_API_URL}/etc/projects/alpitour/terramiotesoro/2020/submissions`;
        break;
      case 'corepla-2020':
        endpoint = `${Settings.V3_API_URL}/etc/projects/corepla/ideaplastica/2020/submissions`;
        break;
    }

    if (submissionId) {
      endpoint += '/' + submissionId;
    } else {
      endpoint += '?include_disabled=1';
    }

    return endpoint;
  }

  fetchData = (projectName, submissionId) => {
    if (!projectName) {
      alert('no project name!');

      return false;
    }

    // get submission
    this.setState((prevState) => {
      prevState.fetching = true;

      return prevState;
    }, () => {
      const endpoint = this.getEndpoint(projectName); // we don't have an endpoint to get a single submission, so get all of them and filter :-/
      if (!endpoint) {
        throw Error('no endpoint to retrieve submissions');
      }

      API.call('GET', endpoint, {},  (response, error) => {
        if (error) {
          this.setState((prevState) => {
            prevState.fetching = false;
            prevState.error = error.message + ' while getting submissions';

            return prevState;
          });

          return false;
        }

        if (!response.ok) {
          this.setState((prevState) => {
            prevState.fetching = false;

            prevState.error = 'Error getting submission (API call failed)';

            return prevState;
          });

          return false;
        }

        let submissionData = null;
        if (submissionId) {
          submissionData = response.data.submissions.find(submission => submission.uuid == submissionId);
        }

        this.setState((prevState) => {
          prevState.fetching = false;

          prevState.submissions = response.data.submissions;
          prevState.submissionData = submissionData;

          return prevState;
        });
      });
    });
  }

  handleSubmissionChange = (propName, value) => {
    this.setState((prevState) => {
      prevState.submissionData[propName] = value;

      return prevState;
    })
  }

  handlePictureChange = (e) => {
    const elem = e.currentTarget;
    const file = elem.files[0];

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      this.setState({
        submissionPictureBase64: event.target.result
      });
    };
  }

  handleSubmissionSave = (propName, value) => {
    const projectName = this.props.match.params.projectName;
    const submissionId = this.props.match.params.submissionId.replace('-', '');
    const { submissionData, submissionPictureBase64 } = this.state;

    console.log('state', this.state);

    const payload = {
      form: submissionData,
      img: {
        base64: submissionPictureBase64
      }
    };

    const endpoint = this.getEndpoint(projectName, submissionId);
    API.call('PUT', endpoint, payload, (response, error) => {
      if (error || !response.ok) {
        alert('Could not update item');
      }

      this.setState({
        feedback: 'Modifiche salvate correttamente.',
        feedbackType: 'success'
      }, () => {
        window.setTimeout(() => {
          this.setState({
            feedback: '',
            feedbackType: ''
          });
        }, 2000)
      })
    });
  }

  render() {
    const projectName = this.props.match.params.projectName;
    const submissionId = this.props.match.params.submissionId.replace('-', '');

    if (this.state.fetching) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Spinner message="Recupero dati..." />
            </div>
          </div>
        </div>
      );
      return <div></div>;
    }

    if (this.state.error) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              ERROR: {this.state.error}
            </div>
          </div>
        </div>
      );
    }

    if (!submissionId) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1>Elaborati <em>{projectName}</em></h1>

              <table border="0" width="100%" className="table table-striped border border-secondary mt-4">
                <thead>
                  <tr>
                    <th width="150">Immagine</th>
                    <th>Scuola</th>
                    <th width="60">Classe</th>
                    <th width="120"></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.submissions.map((submissionData) => {
                      return (
                        <tr style={{backgroundColor: submissionData.enabled ? '#e1f9cf' : '#fbcacf'}}>
                          <td align="center" valign="middle"><img width="100" src={submissionData.picture_url} /></td>
                          <td align="left" valign="middle">{submissionData.school_name} {submissionData.school_location}</td>
                          <td align="left" valign="middle">{submissionData.schoolclass}</td>
                          <td align="center" valign="middle"><Link to={`/etc/projects/${projectName}/${submissionData.uuid}/`}><i className="fa fa-edit mr-2" /> modifica</Link></td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      );
    }

    const { submissionData } = this.state;
    if (!submissionData) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              ERROR: NO SUBMISSION DATA
            </div>
          </div>
        </div>
      );
    }

    const pictureStyle = {width: 'calc(50% - 20px)', height: 'auto', marginRight: '20px'};

    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p><Link to={`/etc/projects/${projectName}/-/`}><button className="btn btn-secondary"><i className="fa fa-arrow-left mr-2" />torna ad indice</button></Link></p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <h1>
              {submissionData.school_name} {submissionData.school_location}<br />
              <small className="text-secondary">ID #{submissionId}</small>
            </h1>

            <div className="row no-gutters">
              <div className="col-4">
                {
                  !this.state.submissionPictureBase64 ? (
                    <p><a href={submissionData.picture_url} target="_BLANK"><img style={pictureStyle} src={submissionData.picture_url} /></a></p>
                  ) : (
                    <p><img style={pictureStyle} src={this.state.submissionPictureBase64} /></p>
                  )
                }
                <p className="mr-4">
                  Seleziona file per sostituire immagine:<br />
                  <input className="form-control" type="file" name="submission_picture" onChange={this.handlePictureChange} />
                </p>
              </div>
              <div className="col-8">
                <div className="mt-2 mb-4">
                  <label className="mb-0"><input type="checkbox" checked={this.state.submissionData.enabled} onChange={(e) => this.handleSubmissionChange('enabled', Number(e.currentTarget.checked))} /> abilitato</label>
                </div>
                {
                  [
                    {
                      prop: "school_name",
                      label: 'Nome scuola'
                    },
                    {
                      prop: "schoolclass_grade",
                      label: 'Classe'
                    },
                    {
                      prop: "schoolclass_sect",
                      label: 'Sez.'
                    },
                    {
                      prop: "school_city",
                      label: 'Città'
                    },
                    {
                      prop: "school_provice_iso_code",
                      label: 'Provincia'
                    }
                  ].map((property) => {
                    return (
                      <div className="mb-4">
                        <label className="mb-0">{property.label}</label>
                        <input className="form-control" type="text" value={this.state.submissionData[property.prop]} onChange={(e) => this.handleSubmissionChange(property.prop, e.currentTarget.value)} />
                      </div>
                    );
                  })
                }
              </div>
            </div>

            <div>
              <hr />
              {
                this.state.feedback ? (
                  <div className={`mt-2 alert alert-${this.state.feedbackType}`}>
                    <i className="fa fa-check mr-2" />{this.state.feedback}
                  </div>
                ) : (
                  <button className="btn btn-primary" onClick={this.handleSubmissionSave}><i className="fa fa-save mr-2" />Salva modifiche</button>
                )
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ClientProjectsPage;



// WEBPACK FOOTER //
// ./src/pages/etc/projects/ClientProjectsPage.js